/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Rule for determining field value. Used in visible if and email notify if rules
 * @export
 * @interface FieldRule
 */
export interface FieldRule {
    /**
     * Field where the visible if rule is relative to
     * @type {string}
     * @memberof FieldRule
     */
    field?: string;
    /**
     * Value must be equal to this value. If value is specified "true" field must have any value selected
     * @type {string}
     * @memberof FieldRule
     */
    equals?: string;
    /**
     * Value must be not equal to this value.
     * @type {string}
     * @memberof FieldRule
     */
    notEquals?: string;
    /**
     * 
     * @type {Array<FieldRule>}
     * @memberof FieldRule
     */
    and?: Array<FieldRule>;
    /**
     * 
     * @type {Array<FieldRule>}
     * @memberof FieldRule
     */
    or?: Array<FieldRule>;
}

export function FieldRuleFromJSON(json: any): FieldRule {
    return FieldRuleFromJSONTyped(json, false);
}

export function FieldRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldRule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'field': !exists(json, 'field') ? undefined : json['field'],
        'equals': !exists(json, 'equals') ? undefined : json['equals'],
        'notEquals': !exists(json, 'not-equals') ? undefined : json['not-equals'],
        'and': !exists(json, 'and') ? undefined : ((json['and'] as Array<any>).map(FieldRuleFromJSON)),
        'or': !exists(json, 'or') ? undefined : ((json['or'] as Array<any>).map(FieldRuleFromJSON)),
    };
}

export function FieldRuleToJSON(value?: FieldRule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'field': value.field,
        'equals': value.equals,
        'not-equals': value.notEquals,
        'and': value.and === undefined ? undefined : ((value.and as Array<any>).map(FieldRuleToJSON)),
        'or': value.or === undefined ? undefined : ((value.or as Array<any>).map(FieldRuleToJSON)),
    };
}


